export default __webpack_public_path__ + "static/media/Refund-Policy.23c8dd27.jpg";